import { CompanyPage } from './../company/company';
import { Component, OnInit } from '@angular/core';
import { Companies } from 'api/collections';
import { Company } from 'api/models';
import { ModalController, Alert, AlertController, NavController } from 'ionic-angular';
import { MeteorObservable } from 'meteor-rxjs';
import { Events } from 'ionic-angular/util/events';
import { NewCompanyPage } from '../new-company/new-company';
import { APP_TITLE } from '../../services/config';
import { HttpService } from '../../services/httpService';
import { App } from "ionic-angular";
import { Http } from '@angular/http';
import { SharedService } from '../../services/sharedService';

@Component({
  templateUrl: 'all-companies.html',
  selector: 'all-companies-page'
})
export class AllCompaniesPage implements OnInit {
  companies?: Company[];
  constructor(
    private _app: App,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private navCtrl: NavController,
    private events: Events,
    private sharedService: SharedService,

    public httpService: HttpService
  ) {
  }
  ionViewDidEnter() {
    this._app.setTitle(APP_TITLE);
  }

  goToCompany(company): void {
    this.events.publish('rootNavPush', CompanyPage, { companyId: company._id, withBackButton: true });
  }

  goToAddCompany(): void {
    const modal = this.modalCtrl.create(NewCompanyPage, {}, {enableBackdropDismiss: false});
    modal.present();
  }

  ngOnInit() {
    console.log('all companies page');
    /*
    MeteorObservable.subscribe('allCompanies').subscribe(() => {
      this.companies = this.findCompanies();
    });
    */
    this.httpService.MeteorSubscribe('allCompanies')
    .then(res=>this.httpService.privateLoopAction(true))
    .then(res=>{
      this.companies = this.findCompanies();  
    });

    MeteorObservable.autorun().subscribe(()=>{
      this.companies = this.findCompanies();
    });
  }

  findCompanies(): Company[] {
    return Companies.find().fetch();
  }

  removeCompany(company: Company): void {
    const alert = this.alertCtrl.create({
      title: 'Confirm',
      message: `Are you sure you would like to delete this Company?`,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Yes',
          handler: () => {
            /*
            MeteorObservable.call('removeCompany', company._id).subscribe({
              error: (e: Error) => {
                if (e) {
                  this.showError(e);
                }
              }
            });
            */
            this.httpService.MeteorCall('removeCompany', company._id)
              .then(() => {})
              .catch((e: Error) => {
                if (e) {
                  this.showError(e);
                }
              });
            alert.dismiss();
            return false;
          }
        }
      ]
    });
    alert.present();
  }

  showError(e: Error): void {
    console.error(e);

    const alert = this.alertCtrl.create({
      buttons: ['OK'],
      message: e.message,
      title: 'Oops!'
    });

    alert.present();
  }
  showAlert() {
    const alert = this.alertCtrl.create({
      title: 'Support',
      subTitle: 'This is a demo placeholder for support modal',
      buttons: ['OK']
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/all-companies/all-companies.ts